"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "company-form-page"
  }, [_c("el-card", {
    staticClass: "company-card",
    attrs: {
      shadow: "never"
    }
  }, [_c("div", {
    staticClass: "form-header"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v(" Company Details ")]), _c("div", {
    staticClass: "subtitle"
  }, [_vm._v(" Manage company information ")])]), _c("el-form", {
    ref: "formData",
    staticClass: "modern-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "top"
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "enabled"
    }
  }, [_c("div", {
    staticClass: "switch-row"
  }, [_c("span", {
    staticClass: "switch-label"
  }, [_vm._v("Enabled")]), _c("el-switch", {
    attrs: {
      "active-color": "#13ce66"
    },
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1)]), _c("el-form-item", {
    attrs: {
      label: "Company Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter company name",
      clearable: ""
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("div", {
    staticClass: "mobile-section"
  }, [_c("div", {
    staticClass: "section-label"
  }, [_vm._v(" Mobile Numbers ")]), _vm._l(_vm.formData.mobileNumbers, function (mobile, index) {
    return _c("div", {
      key: index,
      staticClass: "mobile-row"
    }, [_c("el-input", {
      staticClass: "mobile-input",
      attrs: {
        placeholder: "Enter mobile number",
        clearable: ""
      },
      model: {
        value: _vm.formData.mobileNumbers[index],
        callback: function ($$v) {
          _vm.$set(_vm.formData.mobileNumbers, index, $$v);
        },
        expression: "formData.mobileNumbers[index]"
      }
    }, [_c("i", {
      staticClass: "el-input__icon el-icon-phone",
      attrs: {
        slot: "prefix"
      },
      slot: "prefix"
    })]), _c("div", {
      staticClass: "mobile-buttons"
    }, [_vm.formData.mobileNumbers.length > 1 ? _c("el-button", {
      attrs: {
        type: "danger",
        icon: "el-icon-delete",
        size: "mini",
        circle: ""
      },
      on: {
        click: function ($event) {
          return _vm.removeMobile(index);
        }
      }
    }) : _vm._e(), index === _vm.formData.mobileNumbers.length - 1 ? _c("el-button", {
      attrs: {
        type: "primary",
        icon: "el-icon-plus",
        size: "mini",
        circle: ""
      },
      on: {
        click: _vm.addMobile
      }
    }) : _vm._e()], 1)], 1);
  })], 2), _c("el-form-item", {
    attrs: {
      label: "Company Code"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter company code",
      clearable: ""
    },
    model: {
      value: _vm.formData.companyCode,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "companyCode", $$v);
      },
      expression: "formData.companyCode"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Landline Number"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter landline",
      clearable: ""
    },
    model: {
      value: _vm.formData.landlineNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "landlineNumber", $$v);
      },
      expression: "formData.landlineNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Email Address"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter email",
      clearable: ""
    },
    model: {
      value: _vm.formData.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "emailAddress", $$v);
      },
      expression: "formData.emailAddress"
    }
  }, [_c("i", {
    staticClass: "el-input__icon el-icon-message",
    attrs: {
      slot: "prefix"
    },
    slot: "prefix"
  })])], 1), _c("el-form-item", {
    attrs: {
      label: "Company Logo"
    }
  }, [_c("div", {
    staticClass: "icon-upload-wrapper"
  }, [_vm.formData.logo ? _c("div", {
    staticClass: "icon-preview"
  }, [_c("img", {
    attrs: {
      src: _vm.formData.logo
    }
  }), _c("div", {
    staticClass: "overlay"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    },
    on: {
      click: function ($event) {
        _vm.formData.logo = "";
      }
    }
  }, [_vm._v(" Change ")])], 1)]) : _c("div", {
    staticClass: "upload-box",
    on: {
      click: _vm.triggerFileInput
    }
  }, [_c("i", {
    staticClass: "el-icon-plus upload-icon"
  }), _c("div", {
    staticClass: "upload-text"
  }, [_vm._v(" Upload Logo ")]), _c("small", [_vm._v(" PNG / JPG ")]), _c("input", {
    ref: "fileInput",
    attrs: {
      type: "file",
      accept: ".jpg,.jpeg,.png",
      hidden: ""
    },
    on: {
      change: _vm.onFileSelected
    }
  })])])]), _c("el-dialog", {
    attrs: {
      visible: _vm.cropperVisible,
      width: "90%",
      "custom-class": "cropper-dialog",
      "append-to-body": ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.cropperVisible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "cropper-wrapper"
  }, [_c("cropper", {
    ref: "cropper",
    attrs: {
      src: _vm.imageSrc,
      "stencil-props": {
        aspectRatio: 1
      }
    }
  })], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function ($event) {
        _vm.cropperVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.cropImage
    }
  }, [_vm._v(" Crop & Upload ")])], 1)]), _c("el-form-item", {
    attrs: {
      label: "State",
      prop: "stateId"
    }
  }, [_c("el-select", {
    staticClass: "full-width",
    attrs: {
      placeholder: "Select State",
      filterable: ""
    },
    model: {
      value: _vm.formData.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "stateId", $$v);
      },
      expression: "formData.stateId"
    }
  }, _vm._l(_vm.states, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Address"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      placeholder: "Enter address"
    },
    model: {
      value: _vm.formData.address,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "address", $$v);
      },
      expression: "formData.address"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Bank Details"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3,
      placeholder: "Enter bank details"
    },
    model: {
      value: _vm.formData.bankDetails,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "bankDetails", $$v);
      },
      expression: "formData.bankDetails"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "GST Number",
      prop: "gstNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter GST"
    },
    on: {
      input: _vm.handleGSTChange
    },
    model: {
      value: _vm.formData.gstNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "gstNumber", $$v);
      },
      expression: "formData.gstNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PAN Number",
      prop: "panNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter PAN"
    },
    model: {
      value: _vm.formData.panNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "panNumber", $$v);
      },
      expression: "formData.panNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Brochure"
    }
  }, [_vm.formData.broucherUrl ? _c("div", {
    staticClass: "brochure-preview"
  }, [_c("i", {
    staticClass: "el-icon-document brochure-icon"
  }), _c("span", {
    staticClass: "brochure-name"
  }, [_vm._v(_vm._s(_vm.brochureFileName))]), _c("div", {
    staticClass: "brochure-actions"
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "primary",
      icon: "el-icon-view"
    },
    on: {
      click: _vm.openBrochure
    }
  }, [_vm._v(" View ")]), _c("el-button", {
    attrs: {
      size: "mini",
      type: "danger",
      icon: "el-icon-delete"
    },
    on: {
      click: function ($event) {
        _vm.formData.broucherUrl = "";
      }
    }
  }, [_vm._v(" Remove ")])], 1)]) : _c("div", {
    staticClass: "brochure-upload-box",
    on: {
      click: _vm.triggerBrochureInput
    }
  }, [_c("i", {
    staticClass: "el-icon-upload brochure-upload-icon"
  }), _c("div", {
    staticClass: "upload-text"
  }, [_vm._v(" Click to upload Brochure ")]), _c("small", [_vm._v("PDF / DOC / DOCX")]), _c("input", {
    ref: "brochureInput",
    attrs: {
      type: "file",
      accept: ".pdf,.doc,.docx",
      hidden: ""
    },
    on: {
      change: _vm.onBrochureSelected
    }
  })])]), _c("el-form-item", [_c("div", {
    staticClass: "form-actions"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" Save Company ")]), _c("el-button", {
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" Reset ")])], 1)])], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;